import { render, staticRenderFns } from "./PreviewResourceModal.vue?vue&type=template&id=eacdb6f6&scoped=true"
import script from "./PreviewResourceModal.vue?vue&type=script&lang=js"
export * from "./PreviewResourceModal.vue?vue&type=script&lang=js"
import style0 from "./PreviewResourceModal.vue?vue&type=style&index=0&id=eacdb6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eacdb6f6",
  null
  
)

export default component.exports